<template>

  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.CareerOpportunities") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.recruitment") }}</span>
        </li>
      </ul>
      <div class="banner">
        <div class="banner__bg">
          <img src="../assets/imgs/CareerOpportunitiesImg.png" />
        </div>
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.company") + $t("i18n.recruitment") }}</h1>
              <p class="banner__text" v-html="$t('i18n.recruitmentText')"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div v-for="(temp, index) of $t('i18n.recruitmentList')" :key="index" class="main-class" v-show="temp.isShow">
              <div class="container-text">
                <span style="font-size: 1.6rem;font-weight: 600;">{{ temp.name }}</span>
              </div>
              <div class="container" v-for="(item, i) of temp.list" :key="i">
                <div>
                  <div class="container-main">
                    <div class="wp-block-columns" >
                      <div class="wp-block-column" >
                        <ul>
                          <li>
                            <span>{{ item.type }}</span>
                            <span>{{ item.typeText }}</span>
                          </li>
                          <li>
                            <span>{{ item.planPeople }}</span>
                            <span v-html="item.planPeopleText"></span>
                          </li>
                          <li class="li-d-f">
                            <div class="li-div-small">{{ item.job }}</div>
                            <div v-html="item.jobText"></div>
                          </li>
                          <li class="li-d-f">
                            <div>
                              <span style="font-size: 14px;font-weight: 600;" v-html="item.salary"></span>
                              <span style="font-size: 14px;font-weight: 600;" v-html="item.salaryText"></span>
                            </div>
                            <div class="container-btn ml-auto" @click="goPage('/contactUs')">{{ $t('i18n.ConsultationImmediately') }}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="section footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="white-box__links">
              <a class="white-box__link" @click="showDetail()">
                <strong class="white-box__link-label">
                  {{ $t("i18n.company") }}
                </strong>
                <h4 class="white-box__link-text">
                   {{ isShow ? $t("i18n.seeMoreRecruitment") : $t("i18n.backHomePage")}}
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "recruitment",
  data() {
    return {
      isShow: true,
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  methods: {
    goPage(path) {
      this.$router.push(path)
    },
    showDetail() {
      if (!this.isShow) {
        this.$router.push('/')
      } else {
        this.isShow = false;
        this.$t('i18n.recruitmentList').forEach(item => {
          item.isShow = true
        })
      }
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  }
}
</script>

<style scoped>

.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  height: 61rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 61rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
}
.main-class {
  margin-top: 10rem;
  margin-bottom: 10rem;
  border: .1rem solid #990099;
}

.container {
  width: 100%;
}
.container-text {
  width: 100%;
  height: 5rem;
  font-weight: 400;
  font-size: 2.4rem;
  color: #FFFFFF;
  background-color: #990099;
  display: flex;
  align-items: center;
  justify-items: center;
}

.container-text span {
  margin-left: 3rem;
}

.wp-block-columns {
  display: flex;
  flex-wrap: wrap;
}
.wp-block-columns .wp-block-column:first-child {
  padding-right: 2rem;
}
.wp-block-columns .wp-block-column {
  margin: 0 1.5rem!important;
}
.properties-title {
  font-size: 1.2rem;
  font-weight: 400;
  color: black;
}
.properties-text {
  font-size: 1.2rem;
  font-weight: 200;
  color: black;
}
.container-main {
  /* border-bottom: .1rem solid lightslategray; */
  border-bottom: 1px solid lightslategray;
  margin-top: 2rem;
}
.li-d-f {
  display: flex;
}
.li-div-small {
  width: 7rem;
}
.container-btn {
  background-color: #990099;
  color: white;
  width: 10rem;
  text-align: center;
  height: 2.4rem;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}


.white-box__links {
  cursor: pointer !important;
  position: relative;
  z-index: 2;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  display: flex;
  min-height: 18rem;
  width: 60rem;
  overflow: hidden;
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
  margin-bottom: 3rem;
}
.white-box__link:last-child {
  border: 0 !important;
}
.white-box__link {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5rem;
  border-right: 0.1rem solid #e6e6e6;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-label, .white-box__link-label {
  font-weight: 500;
  font-size: 1.3rem;
  color: black;
  letter-spacing: .035rem;
  text-transform: uppercase;
  display: block;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text, .white-box__link-text {
  font-weight: 500;
  font-size: 3rem;
  color: #990099;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  padding-right: 1.5rem;
  margin: 0;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text:after, .white-box__link-text:after {
  content: "";
  position: absolute;
  padding-right: 2rem;
  right: 0;
  width: 0.8rem;
  height: 1.4rem;
  top: 1.2rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}

</style>



// WEBPACK FOOTER //
// src/view/recruitment.vue